@if (telematicsStore.loading(); as loading) {
  <app-modal-loading-section [loading]="loading"></app-modal-loading-section>
} @else if (swap(); as swap) {
  <onyx-information-heading>
    {{ 'labels.plannedSwapPoint' | translate }}

    <onyx-link subheading color="gray" (click)="openSwapModal()">
      {{ swap.data.identifier }}
    </onyx-link>

    <onyx-icon-button
      actions
      variant="transparent"
      color="gray"
      [size]="32"
      icon="map-view-outlined"
      [circle]="true"
      onyxTooltip="labels.showOnMap"
      (click)="showOnMap()"
    ></onyx-icon-button>
  </onyx-information-heading>

  <app-route-point
    [point]="swap.point"
    variant="preview"
    [interactivePreview]="true"
    [forceIcons]="true"
    previewColor="gray"
  ></app-route-point>
}
